module.exports = __webpack_public_path__ + "static/img/4.c88c5889.png";